import styles from './SelectNumber.module.css'
import {useDispatch, useSelector} from "react-redux";
import {ReduxStateInt, setBaseRegion, setOrderData, setSlider} from "../../Reducer/GlobalReducer";
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import WaitLoader from "../../WaitLoader/WaitLoader";
import exp from "constants";
import {Link, useNavigate} from "react-router-dom";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";

export interface SimCardUnitInt
{
    ctn: string
    icc: string
    isSelected:boolean;
}

interface NextButtonCallBackInt
{
    (data:SimCardUnitInt | undefined):void
}

interface SelectNumberPropsInt
{
    cbExecute?: NextButtonCallBackInt
}
interface GetNumberListInt
{
    tarifId?:string
    operId?:string
    macroRegionId?:number
    regionId?:number
    categoryId?:number
    bundleId?:string
}

interface CtnItemInt
{
    sim: SimCardUnitInt;
    selected:boolean
}

export default function SelectNumber({cbExecute}:SelectNumberPropsInt)
{

    const mainCont = useRef<HTMLDivElement>(null)
    const errorLineRef = useRef<ErrorLineItemRef>(null)

    const orderData = useSelector((state: ReduxStateInt) => {
        return state.orderData
    })

    const dispatch = useDispatch()

    const reserveCtnListData = useRef<GetNumberListInt>()
    const [ldrReserveCtnList,rsReserveCtnList,exReserveCtnList] = useApiQuery("/sell/sim/reserve/new","post",reserveCtnListData);


    const reserveSimData = useRef({
        icc:"",
        orderId:orderData.orderId,
        sessionId:orderData.sessionId

    })
    const [ldrReserveSim,rsReserveSim,exReserveSim] = useApiQuery("/sell/sim/reserve/sell","post",reserveSimData);


    const navigate = useNavigate()

    const [ctnList, setCtnList]= useState<SimCardUnitInt[]>([])
    const [ctnItem,setCtnItem] = useState<CtnItemInt[]>([])
    const [selectedCtn, setSelectedCtn] = useState<SimCardUnitInt>({
        isSelected: false,
        icc:"",
        ctn: ""
    })

    const [stage, setStage] = useState(0)

    const [stRes, setStRes] = useState("")


    const [error, setError] = useState({
        error:false,
        text:""
    })

    useEffect(()=>{
        console.log("selected ctn : ",selectedCtn)
    },[selectedCtn])


    useEffect(()=>{
        if(mainCont.current)mainCont.current.scrollIntoView()
        switch (stage)
        {
            case 0://Старт лоад дата
                //if(errorLineRef.current)errorLineRef.current.clear()
                loadData()
                break
            case 2://Выбрался номер
                if(cbExecute && selectedCtn?.isSelected) {
                    cbExecute(selectedCtn)
                }
                break
            case 3://Нет номеров в списке переход далее
                break
            case 4://Список загружен
                break
            default:
                loadData()

        }


    },[stage])


    useEffect(()=>{
        setCtnItem(
            ctnList.map((item,idx)=>{
                const itm:CtnItemInt =
                    {
                        sim: item,
                        selected: idx === 0
                    }
                    if(itm.selected) setSelectedCtn({...itm.sim, isSelected: true})
                return itm
            })
        )

    },[ctnList])

    const loadData = ()=>{
        reserveCtnListData.current = {
            regionId : orderData?.regionData?.regionId,
            operId : orderData?.tarifData?.operId,
            macroRegionId : orderData?.regionData?.macroRegionId,
            tarifId : orderData?.tarifData?.tarifId,
            bundleId : orderData?.tarifData?.bundleId,
        }

        exReserveCtnList().then((e)=>{
            if(e?.success )
            {
                if(e?.payload && Array.isArray(e.payload) && e.payload.length ===0)
                {
                    //if(errorLineRef.current)errorLineRef.current.show("Нет свободных номеров, номер будет присвоен при подключении", true,0)
                    console.log("empty list",errorLineRef.current)
                    setCtnList([])
                    setStage(3)// Список пуст
                    return
                }
                if(e?.payload && Array.isArray(e.payload) )
                {
                    setCtnList(e?.payload)
                    setStage(4)//Список загружен
                    return;

                }

            }
            if(errorLineRef.current)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка загрузки номеров", true,0)
            setCtnList([])

        }).catch((e)=>{
            if(errorLineRef.current)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка загрузки номеров", true,0)
            setCtnList([])
            setStage(3)
        })
    }



    const setSelected = (id: number)=>{
        setCtnItem(
            ctnItem.map((itm,idx)=>{
                if(idx === id)
                {
                    itm.selected = true
                    setSelectedCtn({...itm.sim, isSelected: true})
                }
                else itm.selected = false
                return itm
            })

        )
    }

    const handleNext = () => {
        //if(rpm.isSelected && cbExecute)cbExecute(rpm)
        if (stage === 3 || ctnList.length === 0) {
            dispatch(setOrderData({ctnData:selectedCtn}))
            if (cbExecute) cbExecute(undefined)
            return
        }
        if (stage === 4 && selectedCtn.isSelected)
        {
            reserveSimData.current.icc = selectedCtn.icc
            exReserveSim().then((e)=>{
                if(e?.success) {
                    dispatch(setOrderData({ctnData:selectedCtn}))
                    if (cbExecute) cbExecute(undefined)
                    return
                }
                if(errorLineRef.current)errorLineRef.current.show( "Ошибка резервирования номера, возможно номер уже занят, попробуйте другой",true,0)
                setStage(0)
            }).catch((e)=>{
                if(errorLineRef.current)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка резервирования номера", true,0)
                setStage(0)
            })


        }

    }

    const buildCtnList = ()=>{
        return  ctnItem.map((item,key)=>{
            return(
                <div className={styles.ctnItem} key={key}
                    onClick={()=>{
                        setSelected(key)

                }}
                >
                    <div className={[styles.ctnIcon, item.selected ? styles.ctnIconSelected :"" ].join(' ')}></div>
                    <div>{item?.sim?.ctn}</div>
                </div>
            )
        })
    }

    //if(ctnList.length===0)sendResult();
    return(

            <div className={styles.ctnCont} ref={mainCont}>
                <WaitLoader loading={ldrReserveCtnList} api={rsReserveCtnList} onlyLoading={true} showError={false}>
                </WaitLoader>

                {stage ===4 &&
                    <div>
                        <p className={styles.numTitle}>
                            Для подключения доступны следующие номера. Номер  резервируется на 30 минут. За это время необходимо закончить процедуру оформления заказа. Выберите номер из списка.
                        </p>
                        <div className={styles.ctnCont}>
                            {buildCtnList()}
                        </div>
                    </div>
                }
                {stage === 3 &&
                    <div>
                        <p className={styles.numTitle}>Для данного тарифа и региона не доступен выбор номера, номер будет присвоен позже, в личном кабинете</p>
                    </div>
                }


                <ErrorLineItem ref={errorLineRef} ></ErrorLineItem>


                <div className={styles.btnCont}>
                    <Link to={"/"} className={styles.link}>
                        <div className={styles.btnSelect}
                             onClick={()=>{
                                 dispatch(setSlider({sliderMode:0}))
                             }}
                        >Назад
                        </div>

                    </Link>
                    <div className={styles.btnSelect}
                         onClick={()=>{
                             handleNext()
                         }}
                    >Далее
                    </div>
                </div>
            </div>
    )
}